import { render, staticRenderFns } from "./QuesDesigner.vue?vue&type=template&id=02cf14b2&scoped=true"
import script from "./QuesDesigner.vue?vue&type=script&lang=js"
export * from "./QuesDesigner.vue?vue&type=script&lang=js"
import style0 from "./QuesDesigner.vue?vue&type=style&index=0&id=02cf14b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cf14b2",
  null
  
)

export default component.exports